import { Navigate, useLocation } from 'react-router-dom';

const LoginRedirect = () => {
  const location = useLocation();
  return <Navigate to={location?.state?.from?.pathname || "/"} replace />;
};

export default LoginRedirect;
